"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const reducer_1 = require("../reducer");
const MoreOffers_1 = __importDefault(require("./MoreOffers"));
const PrimePrequalApproval_1 = __importDefault(require("./PrimePrequalApproval"));
function ImprintPresentedOffer({ offers, practiceName, handleAcceptOffer, activeOffer, }) {
    const offerScreen = (0, react_redux_1.useSelector)(reducer_1.selectors.offerScreen);
    const offerToUse = activeOffer ? activeOffer : offers[0];
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: offerScreen === 'PRESENTED OFFER' ? ((0, jsx_runtime_1.jsx)(PrimePrequalApproval_1.default, { handleAcceptOffer: handleAcceptOffer, practiceName: practiceName, offer: offerToUse, approvalAmount: offerToUse.amount, offerMeetsApprovalRequest: true, hasMultipleOffers: offers.length > 1 })) : ((0, jsx_runtime_1.jsx)(MoreOffers_1.default, { offers: offers })) }));
}
exports.default = ImprintPresentedOffer;
